define('apps/admin/views/validation-message',[
        'njs!apps/admin/templates/includes/_validation_message(params:tmpl=admin/main/includes/_validation_message.html)',
    ], function(template) {
        'use strict';

        return Mn.ItemView.extend({

            "template": template,

            "tagName": "div",

            "className": function() {
                return "admin-validation-message" + " admin-validation-message--" + this.model.get('messageType');
            },

        });
});

